import { AnimatePresence, motion } from "framer-motion";
import hamburger from "../../images/shared/icon-hamburger.svg";
import close from "../../images/shared/icon-close.svg";

const MenuButton = ({ menuOpen, setMenuOpen }) => {
	return (
		<AnimatePresence exitBeforeEnter>
			<motion.div
				key={menuOpen}
				animate={{ opacity: 1 }}
				initial={{ opacity: 0 }}
				exit={{ opacity: 0 }}
				transition={{ duration: 0.5 }}
				onClick={() => setMenuOpen(!menuOpen)}
				className='md:hidden z-10'
			>
				{menuOpen ? (
					<img src={close} alt='close menu' />
				) : (
					<img src={hamburger} alt='menu' className='h-13' />
				)}
			</motion.div>
		</AnimatePresence>
	);
};

export default MenuButton;
